import ApiService from "../../services/ApiService";
import Logger from "../../services/Logger";

const UserLayoutService = {
    postMailingList: async (email) => {
        let body = {
            email: email,
        };

        const result = await ApiService.postData("/home/mailing-list", body);
        // Logger.log(result);

        if (result.code === "FAILURE") {
            throw result.message;
        }
    },

    unsubscribeMailingList: async (email, verifyCode) => {
        let body = {
            email: email,
            verifyCode: verifyCode,
        };

        const result = await ApiService.postData("/home/mailing-list/unsubscribe", body);

        if (result.code === "FAILURE") {
            throw result.message;
        }
    },

    requestRootGenre: async () => {
        let body = {
            active: true,
            rootOnly: true,
        };

        const result = await ApiService.getData("/home/genre", body);
        Logger.log(result);

        if (result.code === "FAILURE") {
            throw result.message;
        }
        return result;
    },
};

export default UserLayoutService;
